/**
 * Created by Crete on 17/7/24.
 */
// import {_webapp} from '../config/webapp.js'
import axios from 'axios'
import qs from 'qs'
// import {_webapp} from '../config/_webapp.js'
import {
  _webapp
} from '../config/hook.js'
import {
  MessageBox
} from 'mint-ui'

// import {fn} from '../config/myUtils.js'

const base = 'http://192.168.2.178:8088';
// const base = 'https://api.duoyunjiav2.wshoto.com';
const header = 'application/json';
const dataType = 'json';

/**
 * axios需要将post方法中的需要上传的参数使用qs库进行编码
 */

let axios_instance = axios.create({
  transformRequest: [function (data) {
    data = qs.stringify(data)
    return data
  }],
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'addons': 'ewei_shop',
    'Accept': 'application/json, text/javascript, */*; q=0.01'
  }
})

/**
 * 判断接口的信息是否正确
 * @param opt
 * @returns {Array}
 */
let resulthandling = (opt) => {
  let newData = []
  opt.statusCode = opt.statusCode / 1;
  if (opt.statusCode === 1) {
    newData = {
      'statusCode': opt.statusCode,
      'data': opt.res
    };
  } else {
    if (opt.statusCode === 10005) {
      // newData = {'statusCode' : -1, 'data' : '获取用户信息失败，可能是在其他设备中登陆'};
      MessageBox({
        title: '友情提示',
        message: '获取用户信息失败，可能是登陆超时或在其他设备中登陆，点击确认将为您跳转至登陆页面',
        showCancelButton: false,
        closeOnClickModal: false
      }).then(action => {
        _webapp.nativeLogin();
      });

      return;
    } else if (opt.statusCode === 10010) {
      _webapp.log('opt.statusCode 10010 running.');
      _webapp.getApiToken(() => {
        if (_webapp.checkApiToken()) {
          setParams(opt.params, opt.callback);
          return false;
        } else {
          MessageBox({
            title: '友情提示',
            message: '很抱歉，系统可能出现了点问题，请您关闭APP（需后台任务清除）后重新尝试',
            showCancelButton: false,
            closeOnClickModal: false
          }).then(action => {
            _webapp.nativeLogin();
            // newData = _webapp.getApiTokenSync() || {'statusCode': -1, 'data': '获取公众号通讯令牌异常，请关闭app后重新尝试'};
          });
        }
      });
    } else {
      newData = {
        'statusCode': opt.statusCode,
        'data': opt.res
      };
    }
  }

  return newData
}

/**
 * 判断请求方法，对应请求函数
 *
 **/
let breviaryfoo = opt => {
  switch (opt.type) {
    case 'POST':
      return axios_instance.post(opt.url + '?access_token=' + opt.apitoken, opt.params).then(res => {
        return {
          'res': res.data.result,
          'statusCode': res.data.statusCode,
          'params': opt.params,
          'callback': opt.callback
        }
      }).then(resulthandling).then(opt.callback)
      break;
    case 'PUT':
      return axios_instance.put(opt.url + '?access_token=' + opt.apitoken, opt.params).then(res => {
        return {
          'res': res.data.result,
          'statusCode': res.data.statusCode,
          'params': opt.params,
          'callback': opt.callback
        }
      }).then(resulthandling).then(opt.callback)
      break;
    case 'DELETE':
      return axios_instance.delete(opt.url + '?access_token=' + opt.apitoken, {
        params: opt.params
      }).then(res => {
        return {
          'res': res.data.result,
          'statusCode': res.data.statusCode,
          'params': opt.params,
          'callback': opt.callback
        }
      }).then(resulthandling).then(opt.callback)
      break;
    case 'GET':
      return axios_instance.get(opt.url + '?access_token=' + opt.apitoken, {
        params: opt.params
      }).then(res => {
        return {
          'res': res.data.result,
          'statusCode': res.data.statusCode,
          'params': opt.params,
          'callback': opt.callback
        }
      }).then(resulthandling).then(opt.callback)
      break;
  }
}

/**
 * 获取access_token,auth_key
 */
let isgetApiToken = (r) => {

  if (_webapp.checkApiToken()) {
    let access_token = _webapp.apiToken.data.access_token;
    let auth_key = _webapp.apiToken.data.auth;

    return {
      'access_token': access_token,
      'auth_key': auth_key,
    }
  } else {
    _webapp.log('api.js 111 running');

    if (r === true) {
      return {};
    }

    _webapp.getApiToken(() => {
      _webapp.log('api.js 109 running.');
      if (_webapp.checkApiToken()) {
        isgetApiToken(true);
      } else {
        _webapp.log('getApiToken fail.');
      }
    })
  }
}

export let iGetApiToken = function (callback) {
  if (_webapp.checkApiToken()) {
    callback(true);
  } else {
    _webapp.getApiToken(function () {
      if (_webapp.checkApiToken()) {
        callback(true);
      } else {
        callback(false);
      }
    });
  }
};

export let iGetSessionKey = function (callback) {
  if (_webapp.checkSessionKey()) {
    callback(true);
  } else {
    _webapp.getSessionKey(function () {
      if (_webapp.checkSessionKey()) {
        callback(true);
      } else {
        callback(false);
      }
    });
  }
};

/**
 *  获取sessionkey
 */
let isgetsessionKey = (r) => {
  if (_webapp.checkSessionKey()) {
    return {
      'sessionkey': _webapp.sessionKey.data.sessionkey
    }
  } else {

    if (r === true) {
      return {};
    }

    _webapp.getSessionKey(res => {
      if (_webapp.checkSessionKey()) {
        isgetsessionKey(true)
      }
    })
  }
}


/**
 * 配置请求参数
 */
let setParams = (params, callback) => {
  // _webapp.log('setParams params');
  // _webapp.log(params);
  let param = params.data
  let type = params.method
  let url = params.url
  let sessionkey = ''
  let auth_key = ''
  let access_token = ''

  let apiToken = _webapp.getApiTokenSync();
  let sessionKey = _webapp.getSessionKeySync();
  param['sessionkey'] = sessionKey.data.sessionkey;
  param = _webapp.getSignData(param, apiToken.data.auth_key);
  // _webapp.log(param);
  return breviaryfoo({
    type: type,
    url: url,
    params: param,
    callback,
    apitoken: apiToken.data.access_token
  })
}


/**
 * app支付接口
 */
export const paymentFun = function (type, params, callback) {
  _webapp.payment(type, params, function (res) {
    callback(res)
  })
};
/**
 * 二维码获取
 * @param params
 * @param callback
 * @constructor
 */
export const Qrimg = function (params, callback) {
  /*_webapp.requestx(Object.assign(params, qrimg), function (res) {
    callback(res)
  })*/
  setParams(Object.assign(params, qrimg), callback);
};

/**
 * 保存二维码
 */
export const QrimgSave = function (url) {
  _webapp.shellQrcode(url, function (res) {
    callback(res)
  })
};

/**
 * 退出登录 yellowStar
 */
export const LOGINOUT = function () {
  _webapp.logOut((res) => {})
}


/**
 * 公司信息设置
 */
const company = {
  reqCompanyInfo: {
    url: `${base}/api/page/reqCompanyInfo`,
    method: 'GET',
    header,
    dataType
  }, //公司详情
}


/*
 * 获取公司详情
 * */

export const ReqCompanyInfo = function (params, callback) {
  setParams(Object.assign(params, company.reqCompanyInfo), callback)
};



// WEBPACK FOOTER //
// ./src/api/api.js